@if (productGroup) {
  <div
    class="card-phone-header"
    [ngStyle]="{ 'background-color': headerColor }"
    >
    @if (!hideHamburger) {
      <i class="tool fa fa-bars"></i>
    }
    @if (showTitle) {
      <h3 class="card-phone-title">{{ headerTitle }}</h3>
    }
  </div>
}
